/** 邮箱格式校验 */
export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

/** 手机号格式校验（6–15 位数字，忽略空格） */
export function isPhone(value: string): boolean {
  return /^\d{6,15}$/.test(value.replace(/\s/g, ''))
}

/** E.164 手机号校验：+ 号开头，共 6–15 位数字（后端登录接口要求，如 +6591234567） */
export function isE164(value: string): boolean {
  return /^\+\d{6,15}$/.test(value)
}

/** 用户名校验：4–20 位字母、数字或下划线 */
export function isValidUsername(value: string): boolean {
  return /^\w{4,20}$/.test(value)
}

/** 登录密码校验：须同时包含字母与数字 */
export function hasLetterAndDigit(value: string): boolean {
  return /[A-Za-z]/.test(value) && /\d/.test(value)
}

/** 密码强度校验：8–64 位非空白字符，且同时包含字母与数字（后端 password 字段上限 64） */
export function isValidPassword(value: string): boolean {
  return /^(?=.*[A-Za-z])(?=.*\d)\S{8,64}$/.test(value)
}

/** 赚钱页 ID / 绑定码输入上限 */
export const DIGIT_INPUT_MAX_LEN = 10

/** 仅保留数字；传入 maxLength 时截断 */
export function digitsOnly(value: string, maxLength?: number): string {
  const digits = value.replace(/\D/g, '')
  return maxLength != null ? digits.slice(0, maxLength) : digits
}

/** 手机号规范化：仅数字，允许开头一个 + */
export function sanitizePhone(v: string): string {
  const s = v.replace(/[^\d+]/g, '')
  return s.startsWith('+') ? '+' + s.slice(1).replace(/\+/g, '') : s.replace(/\+/g, '')
}

/**
 * 邮箱规范化（结构性矫正）：
 * 1) 剥非邮箱字符；2) 首字符必须字母/数字（杜绝 --- / ... 类全符号乱输）；
 * 3) @ 至多一个；4) 域名段仅字母/数字/./- 且首个字符须为字母/数字。
 */
export function sanitizeEmail(v: string): string {
  const s = v.replace(/[^A-Za-z0-9@._%+-]/g, '').replace(/^[^A-Za-z0-9]+/, '')
  const at = s.indexOf('@')
  if (at === -1) return s
  const domain = s
    .slice(at + 1)
    .replace(/[^A-Za-z0-9.-]/g, '')
    .replace(/^[^A-Za-z0-9]+/, '')
  return s.slice(0, at) + '@' + domain
}

/**
 * 「绑定手机 / 邮箱」混合输入规范化：含 @ 或字母按邮箱规则，纯数字/+ 按手机号规则。
 * 用于找回密码等账号渠道未定的输入框。
 */
export function sanitizeContact(v: string): string {
  return /[A-Za-z@]/.test(v) ? sanitizeEmail(v) : sanitizePhone(v)
}
